import {
  cookGridData,
  saveItem,
  randomChess,
  generateCell,
  removeAllChess,
  removeChess,
  refreshGrid,
  updateScriptGrids,
} from './cookGridData.js'
import * as gridViewScript from '@ps/bridge/qc/scripts/grid-view'
import gameIframe from '@ps/bridge/iframe/iframe'
import _ from 'lodash'
import * as editorScript from '@ps/bridge/qc/scripts/editor'
import { nodeTypes } from '@ps/bridge/qc/scripts/editor'
import { EventBus, Event } from '@ps/utils/event-bus'
import { getDescendants } from '@ps/bridge/qc/node/utils'
import store from '@ps/store'
import { isImage } from '@ps/bridge/qc/base'
import assets from '@ps/bridge/qc/assets'

const getInitState = () => {
  return {
    editType: '',
    gridsConfig: null,
    gridResourcePath: '',
    selectedChess: '',
    gridDrag: false,
  }
}

export default {
  namespaced: true,

  state: getInitState(),

  getters: {},

  mutations: {
    updateCellActive(state, { rowIndex, colIndex, active } = {}) {
      if (
        state.gridsConfig.cells[rowIndex] &&
        state.gridsConfig.cells[rowIndex][colIndex]
      ) {
        state.gridsConfig.cells[rowIndex][colIndex].active = active
      }
    },
    updateGridPercent(state, percentMap) {
      state.gridsConfig.percentConfig.percentMap = {
        ...state.gridsConfig.percentConfig.percentMap,
        ...percentMap,
      }
    },
    removeChess(state, { rowIndex, colIndex }) {
      const temp = _.cloneDeep(state.gridsConfig)
      temp.cells[rowIndex][colIndex] = removeChess(
        temp.cells[rowIndex][colIndex],
      )
      state.gridsConfig = temp
    },
    updateCellChess(state, { rowIndex, colIndex, config }) {
      if (
        state.gridsConfig.cells[rowIndex] &&
        state.gridsConfig.cells[rowIndex][colIndex]
      ) {
        state.gridsConfig.cells[rowIndex][colIndex] = {
          ...state.gridsConfig.cells[rowIndex][colIndex],
          ...config,
        }
      }
      const temp = _.cloneDeep(state.gridsConfig)
      state.gridsConfig = temp
    },
    updateSelectedChess(state, id) {
      state.selectedChess = id
    },
    updatePercentActive(state, active) {
      state.gridsConfig.percentConfig.active = active
    },
    updateGridType(state, type = 'normal') {
      state.gridsConfig.gridType = type
    },
    updateCellBackgroundActive(state, active = false) {
      state.gridsConfig.cellBackgroundActive = active
    },
    updateEditType(state, type = 'select') {
      state.editType = type
    },
    resetGridsConfig(state) {
      state.gridsConfig = null
    },
    updateDrag(state, isDrag = false) {
      state.gridDrag = isDrag
    },
    updateGridsConfig(state, config) {
      state.gridsConfig = config
    },
    updateGridResourcePath(state, path) {
      state.gridResourcePath = path
    },
    updateGridItem(state, { items }) {
      state.gridsConfig.items = items
    },
    addGridItem(state, { bin, image }) {
      function randomNumber(n) {
        let rnd = ''
        for (let i = 0; i < n; i++) rnd += Math.floor(Math.random() * 10)
        return rnd
      }
      state.gridsConfig.items.push({
        typeId: Number(randomNumber(8)),
        image,
        bin,
        active: true,
      })
    },
    setGridCellBg(state, { bin, image }) {
      const cellBackground = {
        image,
        bin,
        alpha: 1,
      }
      state.gridsConfig.cellBackground = cellBackground
    },
  },

  actions: {
    initQuickLayout({ commit, state, dispatch, rootState }) {
      const temConfig = cookGridData({ commit, state, dispatch, rootState })
      const currentScene =
        rootState.workspace.game.sceneManager.currentSceneNode
      const gridNode = gameIframe.qcGame.add.node()
      const editorData = editorScript.getScript(gridNode)
      editorData.$data.nodeType = nodeTypes.quickLayout
      gridNode.name = 'grid_node'
      gridNode.width = temConfig.gridWidth
      gridNode.height = temConfig.gridHeight
      const gridScript = gridViewScript.getScript(gridNode)
      gridScript.config = {
        gridsConfig: temConfig,
      }
      currentScene.addChildAt(gridNode, currentScene.children.length)
      EventBus.$emit(Event.ADD_GAME_OBJECT, gridNode.uuid)
      dispatch(
        'workspace/game/updateActiveNode',
        { node: gridNode, record: false },
        {
          root: true,
        },
      )
    },
    setCellsActive(
      { commit, state, dispatch, rootState },
      { rowIndex, colIndex, active } = {},
    ) {
      commit('updateCellActive', {
        rowIndex,
        colIndex,
        active,
      })
      if (!active) {
        commit('removeChess', {
          rowIndex,
          colIndex,
        })
      }
      dispatch('refreshGridCell')
    },
    setChessInCell(
      { commit, state, dispatch, rootState },
      { rowIndex, colIndex },
    ) {
      const selectChess = state.gridsConfig.items.find(
        (chess) => chess.typeId === Number(state.selectedChess),
      )
      commit('updateCellChess', {
        rowIndex,
        colIndex,
        config: {
          ..._.pick(selectChess, ['bin', 'image', 'typeId']),
        },
      })
      dispatch('refreshGridCell')
    },
    selectAllCells({ commit, state, dispatch, rootState }) {
      state.gridsConfig.cells.forEach((row, rowIndex) => {
        row.forEach((col, colIndex) => {
          commit('updateCellActive', {
            rowIndex,
            colIndex,
            active: true,
          })
        })
      })
      dispatch('refreshGridCell')
    },
    // 使用节点脚本数据初始化gridsConfig
    initGridsConfig({ commit, state, dispatch, rootState }, node) {
      const config = _.cloneDeep(
        node.getScript('ps.GridView').config.gridsConfig,
      )
      commit('updateGridsConfig', config)
      commit(
        'updateGridResourcePath',
        `resource/${config.scene}/${config.group}/`,
      )
    },
    recountCellsPosition({ commit, state, dispatch, rootState }) {
      const tempConfig = refreshGrid(state.gridsConfig)
      commit('updateGridsConfig', tempConfig)
    },
    updateScriptGridsConfig({ commit, state, dispatch, rootState }, { node }) {
      updateScriptGrids(
        node,
        state.gridsConfig,
        rootState.user.info.is_internal_account,
      )
    },
    setChessActive({ commit, state, dispatch, rootState }, chess) {
      const config = _.cloneDeep(state.gridsConfig)
      const temp = config.items.find((item) => item.typeId === chess.typeId)
      temp.active = !temp.active
      commit('updateGridsConfig', config)
      dispatch('refreshGridCell')
    },
    resetToEmpty({ commit, state, dispatch, rootState }, gridNode) {
      const temConfig = cookGridData({ commit, state, dispatch, rootState })
      temConfig.gridWidth = gridNode.width
      temConfig.gridHeight = gridNode.height
      commit('updateGridsConfig', temConfig)
      dispatch('refreshGridCell')
    },
    resetToPrefab({ commit, state, dispatch, rootState }, node) {
      const editorData = editorScript.getScript(node)
      commit('updateGridsConfig', editorData.$data.gridsConfig)
    },
    renderGrid({ commit, state, dispatch, rootState }, node) {
      const gridScript = gridViewScript.getScript(node)
      gridScript.onPsRender()
      EventBus.$emit(Event.CAPTUREGAME)
    },
    randomGridCell({ commit, state, dispatch, rootState }) {
      const config = _.cloneDeep(state.gridsConfig)
      const cells = randomChess(config)
      config.cells = cells
      commit('updateGridsConfig', config)
    },
    clearAllChess({ commit, state, dispatch, rootState }) {
      let config = _.cloneDeep(state.gridsConfig)
      const { cells } = removeAllChess(state.gridsConfig)
      config = {
        ...config,
        cells,
      }
      commit('updateGridsConfig', config)
      dispatch('refreshGridCell')
    },
    clearAllCells({ commit, state, dispatch, rootState }) {
      let config = _.cloneDeep(state.gridsConfig)
      const { cells } = generateCell(state.gridsConfig)
      config = {
        ...config,
        cells,
      }
      commit('updateGridsConfig', config)
      dispatch('refreshGridCell')
    },
    async addGridItem({ commit, state, dispatch, rootState }, { files }) {
      const { bin, image } = await saveItem({
        files,
        resourcePath: state.gridResourcePath,
      })
      commit('addGridItem', {
        bin,
        image,
      })
    },
    async replaceGridItem(
      { commit, state, dispatch, rootState },
      { files, typeId },
    ) {
      const { bin, image } = await saveItem({
        files,
        resourcePath: state.gridResourcePath,
      })
      const items = _.cloneDeep(state.gridsConfig.items)
      const temp = items.find((item) => item.typeId === typeId)
      // 联动更新不完善,先关掉
      // await dispatch('updateRelativeImage', { oriBin: temp.bin, newBin: bin })
      temp.bin = bin
      temp.image = image
      commit('updateGridItem', {
        items,
      })
      dispatch('refreshGridCell')
    },
    refreshGridCell({ commit, state, dispatch, rootState }) {
      const config = refreshGrid(state.gridsConfig)
      commit('updateGridsConfig', config)
    },
    gridNodeResize({ commit, state, dispatch, rootState }, node) {
      let config = node.getScript('ps.GridView').config.gridsConfig
      config.gridWidth = node.width
      config.gridHeight = node.height
      config = refreshGrid(config)
      updateScriptGrids(node, config, rootState.user.info.is_internal_account)
      dispatch('renderGrid', node)
    },
    setGridCellBgActive({ commit, state, dispatch, rootState }, { active }) {
      commit('updateCellBackgroundActive', active)
      dispatch('refreshGridCell')
    },
    async updateGridCellBg({ commit, state, dispatch, rootState }, { files }) {
      const { bin, image } = await saveItem({
        files,
        resourcePath: state.gridResourcePath,
      })
      commit('setGridCellBg', {
        bin,
        image,
      })
      dispatch('refreshGridCell')
    },
    async updateRelativeImage({ state }, { oriBin, newBin }) {
      const game = store.state.workspace.game
      const UIRoot = game.UIRoot
      const relativeImage = getDescendants(UIRoot, (node) => {
        if (
          isImage(node) &&
          node.texture &&
          node.texture.atlas &&
          node.texture.atlas.url === state.gridResourcePath + oriBin
        ) {
          return true
        }
        return false
      })
      if (relativeImage.length > 0) {
        const asset = await assets.load({
          url: state.gridResourcePath + newBin,
          override: true,
        })
        const Texture = gameIframe.qc.Texture
        relativeImage.forEach((item) => {
          item.texture = new Texture(asset, 0)
        })
      }
    },
  },
}
